import React from "react";
import ReportTypeScreen from "../../../Components/Reports/ReportTypeScreen";

function ReportedPostCommentReplies() {
  return <ReportTypeScreen reportType="post_comment_reply" />;
}

export default ReportedPostCommentReplies;
